import { identity, contains, isEmpty, isEqual } from 'underscore';
import { mapBulkUpsertErrors } from './map-bulk-upsert-errors';

export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AdGroup: 'adGroup',
  AssetGroup: 'assetGroup',
  Ad: 'ad',
  CampaignLocation: 'campaignLocation',
  CampaignRadius: 'campaignRadius',
  CampaignNegativeLocation: 'campaignNegativeLocation',
  CampaignLocationIntent: 'campaignLocationIntent',
  CampaignDayTimeCriterion: 'campaignDayTimeCriterion',
  CampaignNegativeWebpage: 'campaignNegativeWebpage',
};

export const serverErrorsCompare = (prev, curr) => !(!isEmpty(curr) && !isEqual(prev, curr));

const getBulkUploadEntityType = entitySchema =>
  (entitySchema.properties['bulk-upload-type'] || {}).value ||
  entitySchema.name;

export const getBulkUploadErrorType = entitySchema =>
  `${getBulkUploadEntityType(entitySchema)} Error`;

export const modelToViewModelForBulkErrors = (errors, bulkUpsertEntityErrorMap, scenario, i18n, activityLogger) =>
  mapBulkUpsertErrors(errors, bulkUpsertEntityErrorMap, /* errorProcessor */ identity, scenario, i18n, activityLogger);

const ReferencedEntityInvalidIdErrors = ['CampaignServiceInvalidCampaignId', 'CampaignServiceFutureFeatureCode', 'CampaignServiceInvalidAdGroupId'];
export const removeReferencedEntityInvalidIdErrors = bulkErrors =>
  bulkErrors.filter(({ Error }) => !contains(ReferencedEntityInvalidIdErrors, Error));

export const getPanelErrorProps = ({ needsAttention }) => (needsAttention ? {
  error: _TL_("* Something's wrong"),
} : {});
